// extracted by mini-css-extract-plugin
module.exports = {"content":"EventSection_content__9SOM4","wrapper":"EventSection_wrapper__JAjGq","row":"EventSection_row__ue3cl","icon":"EventSection_icon__05ARm"};